<template>
  <div id="landing-page">
    <div id="cover" class="cover">
      <imageContainer class="image" :imageName="'SZY_9734'" :width="'100%'" :height="'100vh'"></imageContainer>
      <h1>Csepel<br><span>Művek</span></h1>
      <aside class="actual">
        <div class="actual-wrapper">
          <div class="actual-item">
            <a href="https://www.dropbox.com/s/bg9yxj8u4029f0m/CSM_NyitottGyarak_sajto_0612.pdf?dl=0" target="_blank">Sajtó-<br>tájékoztató</a>
          </div>
          <!--<div class="actual-item">-->
            <!--<router-link to="/soundmap">Hangtérkép</router-link>-->
          <!--</div>-->
        </div>
      </aside>
      <div @click="goToSection('#shared-cities')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="shared-cities" class="section section-1">
      <h2>Shared Cities: Creative Momentum</h2>
      <p class="shared-cities" v-for="text in texts.sharedCities">{{text}}</p>
      <div @click="goToSection('#img-1')" class="arrow">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div class="image-section" id="img-1">
      <div class="decoration decoration-1"></div>
      <imageContainer class="image"
                      :imageName="'SZY_9670'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <div @click="goToSection('#kek')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="kek" class="section section-2">
      <h2>Kortárs Építészeti Központ</h2>
      <p v-for="text in texts.kek">{{text}}</p>
      <div @click="goToSection('#csepel')" class="arrow">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="csepel" class="section section-3">
      <!-- TODO text -->
      <h2>A KÉK tevékenysége a Shared Cities - Creative Momentum projekt keretében:</h2>
      <p v-for="text in texts.city">
        <strong>Working with the city</strong>
        <br>
        {{text}}
      </p>
      <p v-for="text in texts.csepel">
        <strong>Csepel Művek</strong>
        <br>
        {{text}}
      </p>
      <div @click="goToSection('#img-2')" class="arrow">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div class="image-section" id="img-2">
      <div class="decoration decoration-2"></div>
      <div class="decoration decoration-3"></div>
      <div class="decoration decoration-4"></div>
      <imageGrid :imageList="imageGridList"></imageGrid>
    </div>
  </div>
</template>

<script>
  import imageContainer from './../components/imageContainer.vue'
  import landingPageTexts from './../assets/data/landingPage.js'
  import imageGrid from './../components/imageGrid.vue'
  import arrowSvg from './../components/arrow.vue'
  import arrowIcon from './../assets/arrow.svg'
  import { scrollToSection } from '../utils'


  export default {
    name: 'landingPage',
    components: {imageContainer, imageGrid, arrowSvg},
    data: function () {
      return {
        arrowIcon,
        texts: landingPageTexts, // TODO
        imageGridList: [
          'SZY_9826', 'SZY_9803', 'SZY_9775',
          'SZY_9807', 'SZY_9797', 'SZY_9685',
          'SZY_9773', 'SZY_9755', 'SZY_9717'
        ]
      }
    },
    methods: {
      goToSection (selector) {
        scrollToSection(selector)
      },
      isMobile() {
        return window.innerWidth <= 600
      }
    },
    mounted () {
      this.$store.dispatch('theme/getTheme', '2020');
    }
  }
</script>

<style scoped>
  #landing-page {
    position: relative;
    text-align: left;
  }

  .cover {
    color: white;
    position: relative;
    height: 100vh;
    background: white;
  }

  .image {
    opacity: 0.8;
  }

  .cover h1, .cover h2 {
    position: absolute;
  }

  .cover h1 {
    left: 30px;
    top: 20vh;
    margin-bottom: 10px;
    font-size: 120px;
    color: var(--colorA);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
  }

  .cover h1 span {
    margin-left: 80px;
  }

  @media (max-width: 600px) {
    .cover {
      height: auto;
      font-size: 0;
    }

    .cover h1 {
      top: 54vh;
      left: 50%;
      font-size: 48px;
      line-height: 1.2;
      text-align: center;
      transform: translateX(-50%);
    }

    .cover h1 span {
      margin: 0;
    }
  }

  @media (max-height: 500px) {
    .cover h1 {
      top: 60px;
      font-size: 96px;
    }
  }

  .actual {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 40px;
    z-index: 10;
    background-color: var(--colorA);
    opacity: 0.7;
  }

  .actual-wrapper {
    border: 2px solid #fff;
  }

  .actual-item {
    position: relative;
    padding: 20px;
    text-align: center;
  }

  .actual-item:not(:last-of-type)::after {
    position: absolute;
    content: '';
    bottom: 0;
    width: 60%;
    height: 2px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    /*border-bottom: 2px solid #fff;*/
  }

  .actual-item p,
  .actual-item a {
    margin: 0;
    line-height: 1.3;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
  }

  @media (max-width: 600px) {
    .actual {
      position: relative;
      background-color: var(--colorA);
    }
  }

  .section {
    width: 100%;
    height: 100vh;
    padding-bottom: 60px;
    padding-right: 120px;
    padding-top: 60px;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border: 10px solid var(--colorB);
  }

  .section h2 {
    margin-top: 0;
    margin-bottom: 30px;
    background-color: var(--colorB);
    color: white;
    min-height: 60px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    padding-right: 60px;
    padding-left: 60px;
    padding-top: 7px;
    align-items: center;
  }


  .section p {
    width: 66%;
    margin-top: 0;
    margin-bottom: 30px;
    margin-left: 90px;
    z-index: 200;
  }

  .section-1 {
    padding-right: 120px;
  }

  .section-1 p:nth-child(5) {
    font-style: italic;
  }

  .section-3 {
    padding-top: 100px;
    flex-direction: row;
    border-bottom: 0 solid white;
  }

  .section-3 p {
    width: 50%;
  }

  @media (max-width: 1024px) {
    .section-3 {
      height: 110vh;
      padding-top: 150px;
    }
  }

  @media (max-height: 768px) {
    .section {
      height: auto;
      padding-top: 90px;
    }

    .section-3 {
      padding-top: 150px;
    }

    .section-3 h2 {
      padding-bottom: 10px;
    }
  }

  @media (max-height: 500px) {
    .section-3 {
      padding-top: 150px;
      flex-direction: column;
    }

    .section p {
      width: 75%;
      margin: 0 auto 30px 90px;
    }
  }

  @media (max-width: 768px) {
    .section {
      height: auto;
      padding-top: 90px;
    }

    .section-3,
    .section-4 {
      padding-top: 150px;
      flex-direction: column;
    }

    .section-3 h2,
    .section-4 h2 {
      padding-bottom: 10px;
    }

    .section p {
      width: 75%;
      margin: 0 auto 30px 90px;
    }
  }


  @media (max-width: 600px) {
    .section {
      padding: 120px 30px 40px;
    }

    .section-3 {
      padding-top: 220px;
    }

    .section h2 {
      font-size: 21px;
      padding-bottom: 10px;
      padding-left: 30px;
    }

    .section p {
      width: 100%;
      margin-left: 0;
      font-size: 16px;
    }
  }

  .image-section {
    width: 100%;
    position: relative;
    font-size: 0;
  }

  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorB);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorB);
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    .arrow {
      bottom: 3vh;
    }
  }

  svg {
    width: 40px;
    height: 40px;
  }

  .arrow.white {
    color: #fff;
    border-color: #fff;
  }

  .decoration {
    position: absolute;
    background-color: var(--colorA);
  }

  .decoration-1 {
    right: 0;
    top: 0;
    width: 120px;
    height: 120vh;
  }

  .decoration-2 {
    left: 0;
    top: 0;
    width: calc(100vw / 3);
    height: calc(100vh / 6);
  }

  .decoration-3 {
    left: calc(100vw / 3);
    top: -15vh;
    width: calc(100vh / 6);
    height: calc(115vh + 120px);
  }

  @media (max-width: 600px) {
    .decoration-3 {
      height: 115vh;
    }
  }

  .decoration-4 {
    left: 0;
    top: 0;
    width: calc(100vw / 3);
    height: calc(100vh / 6);
  }
</style>
